<template>
  <div id="main">
    <div class="section_1">
      <img src="../assets/logo.png">
      <p>Bus event component 1 clicks: {{ component1Clicks }}</p>
      <p>Bus event component 2 clicks: {{ component2Clicks }}</p>
      <a href="https://www.google.rs">Google</a>
      <a href="/docs">Docs</a>
      <div class="router-wrapper">
        <!-- <image-preloader :image_url="imagePreloaderUrl"></image-preloader> -->
        <keep-alive :include="['Component1']">
          <router-view/>
        </keep-alive>
      </div>
    </div>
    <div class="items-wrapper">
      <div class="list" v-for="(item, index) in items" :key="index">
        <component :is="item.type" :key="item.id" :data="item" :index="index"></component>
      </div>
    </div>
  </div>
</template>

<script>
// import router from '../router'
// import Sidebar from './Sidebar'
import UserList from './UserList'
import TaskList from './TaskList'
import ImagePreloader from './ImagePreloader'
import EventBus from '../eventBus'

export default {
  name: 'MainComponent',
  // router: router,
  components: {
    // 'sidebar': Sidebar,
    'user': UserList,
    'task': TaskList,
    'image-preloader': ImagePreloader
  },
  watch: {
    '$route': function (to, from) {
      let keepAliveList = ['Component1']
      if (keepAliveList.indexOf(to.name) !== -1) {
        this.routeShouldKeepAlive = true
      } else {
        this.routeShouldKeepAlive = false
      }
    }
  },
  created () {
    EventBus.$on('component_1_clicked', this.handleComponent1clicked)
    EventBus.$on('component_2_clicked', this.handleComponent2clicked)
  },
  mounted () {
    this.fetchItems()
  },
  data () {
    return {
      items: [],
      routeShouldKeepAlive: false,
      component1Clicks: 0,
      component2Clicks: 0,
      imagePreloaderUrl: 'http://801s121.mars-t.mars-hosting.com/test_api/get_file/3'
    }
  },
  methods: {
    fetchItems () {
      this.$http.get('http://801s121.mars-t.mars-hosting.com/test_api/get_items')
        .then((response) => {
          this.items = response.data.data
        })
    },
    handleComponent1clicked (payload) {
      this.component1Clicks = payload
    },
    handleComponent2clicked (payload) {
      this.component2Clicks = payload
    }
  }
}
</script>

<style>
#main {
  width: 85vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: blue;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
#main .section_1 {
  width: 100%;
  height: 100%;
  background-color: violet;
  max-height: 100%;
}
#main .section_1 .router-wrapper{
  max-height: 40%;
}
#main .items-wrapper {
  height: 40vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-color: black;
  overflow-y: scroll;
  overflow-x: hidden;
}
#main .items-wrapper .list{
  font-size: 200%;
  margin: 2px;
}
</style>



// WEBPACK FOOTER //
// src/components/MainComponent.vue